export const news = [
  {
    id: "n-3001",
    title: "揭幕战惊魂：湖勇大战加时决出胜负，绝杀三分引爆斯台普斯",
    summary: "常规赛揭幕战，湖人与勇士鏖战至加时赛，最后 4.8 秒的一记超远三分成为全场转折，主场球迷沸腾。",
    category: "赛事新闻",
    author: "陈立",
    source: "篮球直播赛事组",
    publishTime: "2026-10-12T12:20:00",
    readTime: 5,
    tags: ["湖人", "勇士", "揭幕战"],
    cover: "https://readdy.ai/api/search-image?query=dramatic%20basketball%20game%20moment%20with%20player%20shooting%20a%20three%20pointer%20under%20spotlight%2C%20blurred%20crowd%2C%20deep%20navy%20tones%20and%20orange%20accents%2C%20cinematic%20sports%20photography&width=800&height=600&seq=bb-news-3001&orientation=landscape",
    content: [
      "北京时间 10 月 12 日，本赛季常规赛揭幕战在斯台普斯中心打响，洛杉矶湖人坐镇主场迎战金州勇士。两支球队从开球起便进入白热化对攻，全场共出现 21 次比分交替领先，最终比赛被拖入加时。",
      "第四节最后 40 秒，湖人依靠连续的挡拆配合追平比分，把比赛带入加时。加时赛还剩 4.8 秒时，湖人后卫在距离三分线外一步的位置接球出手，皮球空心入网，主场瞬间被点燃。",
      "数据方面，湖人全队送出 28 次助攻，三分球 41 投 15 中；勇士则在篮板上以 52 比 44 占优，但关键时刻的两次失误葬送了领先优势。",
      "赛后主教练表示，球队在防守端的轮转速度是本场取胜的关键，同时也坦言球队在进攻端的稳定性仍需提升。双方将在两周后再次交手，届时勇士将回到主场迎来复仇之战。",
      "本场比赛的完整回放与技术统计已上线，篮球直播将持续为球迷提供高清直播与赛后集锦。",
    ],
  },
  {
    id: "n-3002",
    title: "深度解析：无限换防体系如何改变现代篮球的攻防节奏",
    summary: "从换防频率到错位惩罚，我们拆解了这一战术潮流背后的数据逻辑与执行要点。",
    category: "技术分析",
    author: "赵岩",
    source: "篮球直播战术研究室",
    publishTime: "2026-10-12T09:10:00",
    readTime: 8,
    tags: ["战术", "防守", "数据分析"],
    cover: "https://readdy.ai/api/search-image?query=basketball%20tactical%20diagram%20on%20a%20dark%20coach%20whiteboard%20with%20orange%20markers%20and%20arrows%2C%20blueprint%20style%2C%20clean%20analytical%20look&width=800&height=600&seq=bb-news-3002&orientation=landscape",
    content: [
      "过去十年，联盟的防守策略经历了一次静悄悄的革命。无限换防从一种应急手段，逐渐成为强队的常规武器。它的核心逻辑很简单：用持续的人员交换，消除对手通过挡拆制造空位的机会。",
      "数据显示，采用高频换防的球队，对手在挡拆后的每回合得分平均下降 0.12 分。看起来不多，但在一场 100 个回合的比赛里，这相当于将近 12 分的差距。",
      "当然，换防并非没有代价。当内线被迫外扩，篮下的护框高度会明显下降，这就要求弱侧球员拥有极快的协防轮转意识。真正拉开差距的，往往是换防之后的第二次、第三次轮转。",
      "进攻端的应对同样在进化：错位单打、假掩护下顺、短挡拆传球……教练组开始用更复杂的方式惩罚换防。可以说，今天的比赛已经变成了战术板上的实时博弈。",
      "理解这些细节，能让普通球迷在观看直播时看到更多层次。篮球直播的直播画面将逐步加入战术视角，帮助观众读懂每一个回合。",
    ],
  },
  {
    id: "n-3003",
    title: "新赛季 MVP 热门盘点：五位球员领跑早期榜单",
    summary: "综合效率值、球队战绩与关键表现，我们列出了本赛季最有可能冲击 MVP 的五位球员。",
    category: "球员动态",
    author: "林可",
    source: "篮球直播球员观察",
    publishTime: "2026-10-11T20:40:00",
    readTime: 6,
    tags: ["MVP", "球员", "榜单"],
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20basketball%20player%20celebrating%20on%20court%20with%20dramatic%20rim%20lighting%2C%20deep%20blue%20and%20orange%20color%20grade%2C%20cinematic%20portrait&width=800&height=600&seq=bb-news-3003&orientation=landscape",
    content: [
      "新赛季刚过数轮，关于最有价值球员的讨论已经升温。我们从球员效率值、真实命中率、球队战绩和关键时刻表现四个维度，梳理出目前领跑的五位人选。",
      "排名第五的是一位年轻的锋线核心，他在攻防两端的存在感极强，球队的净效率在他上场时提升了 9.4 分。",
      "排名第三到第四的是两位后场指挥官，他们的助攻失误比都位列联盟前列，串联球队的能力是他们最大的加分项。",
      "榜首位置依然被上赛季的得主占据。他场均贡献接近三双的数据，并且在第四节的关键得分上遥遥领先，这几乎是 MVP 评选中最受重视的指标。",
      "当然，赛季还很漫长，伤病与交易都可能改变格局。篮球直播将在每周更新这份榜单，欢迎持续关注。",
    ],
  },
  {
    id: "n-3004",
    title: "国家队集训名单公布：年轻球员占比创历史新高",
    summary: "最新一期集训名单中，25 岁以下球员达到 11 人，球队年轻化进程明显加速。",
    category: "赛事新闻",
    author: "陈立",
    source: "篮球直播赛事组",
    publishTime: "2026-10-11T15:00:00",
    readTime: 4,
    tags: ["国家队", "集训", "年轻球员"],
    cover: "https://readdy.ai/api/search-image?query=team%20of%20young%20basketball%20players%20standing%20together%20in%20a%20bright%20gymnasium%20with%20red%20jerseys%2C%20clean%20documentary%20sports%20photography&width=800&height=600&seq=bb-news-3004&orientation=landscape",
    content: [
      "国家队今日公布了最新一期集训名单，共 20 人入选，其中 25 岁以下球员达到 11 人，占比超过一半，创下近年来的新高。",
      "本次名单中既有在联赛中表现稳定的中生代球员，也有多位首次入选的年轻新星。教练组表示，希望通过集训考察更多年轻人在高强度对抗中的适应能力。",
      "集训将在两周后展开，内容包括体能储备、战术磨合与热身赛检验。球队计划在此期间完成两场国际热身赛。",
      "多位被征召的球员在接受采访时表示，能代表国家队出战是职业生涯的荣誉，会全力以赴争取留队。",
    ],
  },
  {
    id: "n-3005",
    title: "三分革命：数据揭示联盟投射效率的十年变迁",
    summary: "从场均出手次数到出手距离分布，我们用数据回看三分球如何重塑比赛。",
    category: "技术分析",
    author: "赵岩",
    source: "篮球直播战术研究室",
    publishTime: "2026-10-10T18:30:00",
    readTime: 7,
    tags: ["三分", "数据", "趋势"],
    cover: "https://readdy.ai/api/search-image?query=basketball%20flying%20through%20the%20air%20toward%20a%20hoop%20with%20motion%20blur%20and%20dramatic%20orange%20backlight%2C%20dark%20arena%20background%2C%20high%20speed%20photography&width=800&height=600&seq=bb-news-3005&orientation=landscape",
    content: [
      "十年前，三分球还是一种锦上添花的武器；今天，它已经变成了进攻体系的地基。本文用公开数据，回顾这十年间投射方式的剧烈变化。",
      "联盟场均三分出手从十年前的两千多次，增长到如今接近三千五百次，涨幅超过六成。与此同时，中距离出手则持续萎缩，几乎腰斩。",
      "效率是这一切的驱动力。以每回合得分计算，底角三分与篮下进攻依然是最优解，中间区域的中距离则成为效率洼地。球队的战术设计，正围绕着这一结论不断优化。",
      "值得关注的还有出手速度。借助更精准的追踪数据，我们发现球员的平均出手准备时间在缩短，这直接提升了受干扰情况下的命中率。",
      "三分革命仍在继续。未来，我们或许会看到更多球队尝试极端空间打法，把比赛推向新的形态。",
    ],
  },
  {
    id: "n-3006",
    title: "伤病潮来袭：多队核心缺阵，赛季格局或将改写",
    summary: "开季不到两周，已有数名全明星级别球员进入伤病名单，各队轮换深度面临考验。",
    category: "赛事新闻",
    author: "林可",
    source: "篮球直播球员观察",
    publishTime: "2026-10-10T11:20:00",
    readTime: 5,
    tags: ["伤病", "阵容", "赛季"],
    cover: "https://readdy.ai/api/search-image?query=empty%20basketball%20courtside%20bench%20with%20towels%20and%20water%20bottles%20under%20cool%20blue%20lighting%2C%20quiet%20melancholic%20sports%20photography&width=800&height=600&seq=bb-news-3006&orientation=landscape",
    content: [
      "新赛季开打不到两周，联盟已经出现了多起伤病。数名全明星级别的球员因不同程度的伤势进入伤病名单，预计将缺席数周比赛。",
      "对于志在争冠的球队来说，核心球员的缺阵往往意味着战绩的直接波动。历史数据显示，当家球星缺阵时，球队的胜率平均会下降超过 20 个百分点。",
      "与此同时，这也给了年轻球员证明自己的机会。多支球队开始启用轮换末端的球员，个别新秀借此打出了亮眼表现。",
      "医疗团队普遍强调，负荷管理依然是预防伤病的核心。在赛程密集的当下，合理的轮换与恢复安排，比任何单场胜利都更加重要。",
    ],
  },
  {
    id: "n-3007",
    title: "新秀观察：本届选秀前三甲的赛季首月表现",
    summary: "从适应速度到技术短板，我们逐一评估三位高顺位新秀的开季表现。",
    category: "球员动态",
    author: "林可",
    source: "篮球直播球员观察",
    publishTime: "2026-10-09T16:00:00",
    readTime: 6,
    tags: ["新秀", "选秀", "潜力"],
    cover: "https://readdy.ai/api/search-image?query=young%20rookie%20basketball%20player%20practicing%20dribbling%20in%20an%20empty%20gymnasium%20with%20warm%20window%20light%2C%20documentary%20sports%20photography&width=800&height=600&seq=bb-news-3007&orientation=landscape",
    content: [
      "每年选秀大会之后，球迷最关心的问题都是：这些年轻人，到底能不能打？本文聚焦本届选秀的前三甲，复盘他们赛季首月的表现。",
      "状元秀的适应速度超出预期，他在有限的上场时间里展现了出色的护框能力和终结效率，唯一的短板是罚球稳定性。",
      "榜眼秀则经历了明显的起伏，他的持球进攻还需要打磨，但传球视野已经让教练组眼前一亮。",
      "探花秀的定位最为清晰，作为一名 3D 型锋线，他的三分命中率稳定在四成左右，防守端的横移速度也达到了联盟平均水平以上。",
      "新秀的成长从来不是线性的。给他们一点时间，也许下半个赛季，我们会看到完全不同的故事。",
    ],
  },
  {
    id: "n-3008",
    title: "教练视角：快攻转换中的空间与节奏控制",
    summary: "一次成功的快攻，往往取决于抢下篮板后的第一秒。教练组分享了其中的细节。",
    category: "技术分析",
    author: "赵岩",
    source: "篮球直播战术研究室",
    publishTime: "2026-10-09T10:15:00",
    readTime: 7,
    tags: ["快攻", "节奏", "战术"],
    cover: "https://readdy.ai/api/search-image?query=coach%20with%20clipboard%20explaining%20plays%20on%20a%20basketball%20court%20at%20night%20with%20orange%20court%20lights%2C%20cinematic%20sports%20photography&width=800&height=600&seq=bb-news-3008&orientation=landscape",
    content: [
      "快攻是最能点燃观众情绪的进攻方式，但它的成败，往往在抢下篮板的那一瞬间就已经注定。",
      "教练组普遍强调一个概念：第一秒的决策。抢下防守篮板后，是立刻长传发动，还是交给后卫稳住节奏，需要根据场上的人数对比瞬间判断。",
      "空间同样是关键。优秀的快攻球队，会在推进过程中自动拉开边路与底角，形成多打少的进攻层次，让防守方顾此失彼。",
      "节奏控制则体现了一支球队的成熟度。什么时候提速、什么时候落阵地，考验着控球后卫的大局观。",
      "把这三个要素做好，快攻就不再是碰运气，而是一种可以稳定复制的得分手段。",
    ],
  },
  {
    id: "n-3009",
    title: "集锦回顾：本轮十佳球，隔人暴扣与压哨绝杀齐飞",
    summary: "本轮比赛精彩瞬间盘点，从逆天暴扣到压哨三分，一次看个够。",
    category: "视频集锦",
    author: "周舟",
    source: "篮球直播视频组",
    publishTime: "2026-10-08T22:00:00",
    readTime: 3,
    tags: ["集锦", "十佳球", "暴扣"],
    cover: "https://readdy.ai/api/search-image?query=powerful%20basketball%20dunk%20moment%20with%20player%20hanging%20on%20the%20rim%2C%20dramatic%20backlight%20and%20blurred%20crowd%2C%20high%20contrast%20sports%20photography&width=800&height=600&seq=bb-news-3009&orientation=landscape",
    content: [
      "本轮比赛的精彩程度超出预期，多场比赛在最后时刻才分出胜负，也为集锦贡献了大量高光镜头。",
      "排名第一的是一记隔人暴扣，进攻球员在快攻中直接起飞，迎着防守人完成终结，现场解说一度失声。",
      "排名第二的是压哨绝杀。比赛还剩 1.2 秒，落后的球队通过一次精心设计的边线球战术，完成了反超。",
      "此外，本轮还出现了多次精彩的追身封盖与背后传球，展现了球员出色的身体素质与球商。",
      "完整集锦已上线篮球直播视频专区，点击即可观看。",
    ],
  },
  {
    id: "n-3010",
    title: "战术板：如何用短挡拆破解对手的收缩防守",
    summary: "面对钉在禁区里的防守，短挡拆与顺下传球是最有效的应对之一。",
    category: "技术分析",
    author: "赵岩",
    source: "篮球直播战术研究室",
    publishTime: "2026-10-08T14:00:00",
    readTime: 6,
    tags: ["挡拆", "进攻", "战术板"],
    cover: "https://readdy.ai/api/search-image?query=basketball%20court%20half%20line%20diagram%20view%20from%20above%20with%20orange%20and%20blue%20player%20markers%2C%20analytical%20sports%20graphic%20style&width=800&height=600&seq=bb-news-3010&orientation=landscape",
    content: [
      "当对手选择沉退、把防守重心压在禁区时，常规的高位挡拆往往难以奏效。这时候，短挡拆就成了破局利器。",
      "短挡拆的关键在于掩护人下顺的时机与位置。他需要在罚球线附近接球，形成以多打少的局部优势，而不是一味冲向篮下。",
      "接球之后，掩护人有三个选择：自己抛投、分给底角射手，或者传给顺下的队友。防守方必须在极短时间内做出判断，这正是进攻方想要的。",
      "值得注意的是，短挡拆对掩护人的处理球能力要求很高，这也是为什么联盟中真正擅长此道的内线并不多见。",
      "把这项战术练熟，球队在面对各种防守策略时，就能多一份从容。",
    ],
  },
];

export default news;